import React, { useState } from 'react';
import { PhoneIcon, MessageSquareIcon, MapPinIcon, BadgeCheckIcon, ShieldCheckIcon, MailIcon } from 'lucide-react';
import { SITE } from '../constants/site';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  const year = new Date().getFullYear();
  return <footer className="w-full bg-nfblue-dark text-slate-300" data-id="element-60" data-mp="36n3dnoiafsut">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-61" data-mp="3ugbqj7nstejc">
        <div className="grid gap-10 md:grid-cols-3" data-id="element-62" data-mp="3990ijjp5eap">
          <div className="flex flex-col items-center text-center" data-id="element-63" data-mp="36mu4n8jl4u2">
            <img src={SITE.logoUrl} alt={`${SITE.shortName} logo`} className="h-20 w-auto" data-id="element-64" data-mp="3ldkdj3f9yapl" />
            <p className="mt-4 max-w-sm text-sm text-slate-400" data-id="element-65" data-mp="3qcdu54puyhtz">
              {SITE.company}. Local, licensed, and insured irrigation experts serving
              Garland, TX and all of North Texas.
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold" data-id="element-66" data-mp="2ezuvvrhbmiod">
              <span className="flex items-center gap-1.5 text-nfgreen-light" data-id="element-67" data-mp="3la27uq37evt4">
                <BadgeCheckIcon className="h-4 w-4" data-id="element-68" data-mp="3gbimorwfpo1t" />
                License {SITE.license}
              </span>
              <span className="flex items-center gap-1.5 text-nfgreen-light" data-id="element-69" data-mp="3v9b0nfmc24dw">
                <ShieldCheckIcon className="h-4 w-4" data-id="element-70" data-mp="3q7lo1vjgpinp" />
                Fully Insured
              </span>
            </div>
          </div>

          <div data-id="element-71" data-mp="80xjq7w8kzj3">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-72" data-mp="80nvaoqub0fi">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-73" data-mp="ht39rc2xh6vn">
              <li data-id="element-74" data-mp="huwg0q9mpp34">
                <a href={SITE.phoneHref} className="flex items-center gap-2 transition-colors hover:text-white" data-id="element-75" data-mp="ctqrl4n04nze">
                  <PhoneIcon className="h-4 w-4 text-nfgreen-light" data-id="element-76" data-mp="qt03hs46cvxk" />
                  {SITE.phone}
                </a>
              </li>
              <li data-id="element-77" data-mp="mthjcyk6govs">
                <a href={SITE.smsHref} className="flex items-center gap-2 transition-colors hover:text-white" data-id="element-78" data-mp="mptq80ina4hl">
                  <MessageSquareIcon className="h-4 w-4 text-nfgreen-light" data-id="element-79" data-mp="tta06hahyzxr" />
                  Text us anytime
                </a>
              </li>
              <li data-id="element-80" data-mp="13s98fyrcotk8">
                <a href={SITE.emailHref} className="flex items-center gap-2 transition-colors hover:text-white" data-id="element-81" data-mp="13rpuet4tmpbh">
                  <MailIcon className="h-4 w-4 text-nfgreen-light" data-id="element-82" data-mp="18m3qkxrb50h7" />
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-83" data-mp="1hk5zdzha8xf1">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-nfgreen-light" data-id="element-84" data-mp="1hiulv7y1cbaq" />
                Garland, TX & All of North Texas
              </li>
            </ul>
          </div>

          <div data-id="element-85" data-mp="1rid15b3038wg">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-86" data-mp="1ri3jqbw0ua2d">
              Business Hours
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-400" data-id="element-87" data-mp="3t9q4hvpbl8qe">
              <li className="flex justify-between" data-id="element-88" data-mp="3tc2wl1oskzh6">
                <span data-id="element-89" data-mp="2ag5ecolo18fl">Monday - Saturday</span>
                <span className="font-semibold text-white" data-id="element-90" data-mp="2agyeh6q4czor">6:00 AM – 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-91" data-mp="25mkess4fc6ea">
                <span data-id="element-92" data-mp="21nv3d52y4yxa">Sunday</span>
                <span className="font-semibold text-white" data-id="element-93" data-mp="21kpf1s25612m">7:00 AM – 5:00 PM</span>
              </li>
              <li className="mt-3 rounded-lg bg-nfgreen/10 p-3 text-center text-nfgreen-light" data-id="element-94" data-mp="1wlma07m5vuun">
                <span className="block font-bold" data-id="element-95" data-mp="2tbviahd5sew4">24/7 Emergency Service</span>
                <span className="text-xs" data-id="element-96" data-mp="2pcw6qdwx9jvp">Same-day appointments available</span>
              </li>
            </ul>

            <h3 className="mt-8 font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-97" data-mp="2kbgn8qae7lff">
              About Us
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-98" data-mp="18ynupd9s2syb">
              Established April 20, 2022, Northface Irrigation Repair & Services, LLC is your comprehensive solution for all things outdoor. Based in Garland, we specialize in a full spectrum of landscape services, from expert irrigation system repair and drainage solutions to stunning landscape design and tree services.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row" data-id="element-99" data-mp="2iwmase7af55t">
          <p data-id="element-100" data-mp="3bjqhcnm13rjp">
            © {year} {SITE.company}. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-101" data-mp="3bhvzxj9yuhkd">
            <button onClick={() => setModal('privacy')} className="transition-colors hover:text-white" data-id="element-102" data-mp="3fk0ow4pgyq0o">
              Privacy Policy
            </button>
            <button onClick={() => setModal('terms')} className="transition-colors hover:text-white" data-id="element-103" data-mp="36knbj0y85hao">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <LegalModal open={modal === 'privacy'} onClose={() => setModal(null)} title="Privacy Policy" data-id="element-104" data-mp="1v5gvc059eew1">
        <div className="space-y-4" data-id="element-105" data-mp="1nlxusfzz22zp">
          <p data-id="element-106" data-mp="1nkwi673b58fv">
            {SITE.company} ("we," "us," or "our") respects your privacy. This policy
            explains how we collect, use, and protect the information you provide when
            you contact us or request service.
          </p>
          <div data-id="element-107" data-mp="1wkji0oge266t">
            <h4 className="font-bold text-slate-900" data-id="element-108" data-mp="1rnjccengb5g8">Information We Collect</h4>
            <p className="mt-1" data-id="element-109" data-mp="1rlgcl2whxxyb">
              We collect the information you voluntarily provide — such as your name,
              phone number, service address, and details about your property — when you
              call, text, or request an estimate. We use this solely to schedule visits,
              provide quotes, and deliver our irrigation services.
            </p>
          </div>
          <div data-id="element-110" data-mp="18uynr9esbmi8">
            <h4 className="font-bold text-slate-900" data-id="element-111" data-mp="l7h4k29l5wqv">How We Use Your Information</h4>
            <p className="mt-1" data-id="element-112" data-mp="l5e3mn6waj7d">
              Your information is used to respond to inquiries, schedule and perform
              work, send quotes and invoices, and follow up on completed jobs. We do not
              sell or rent your personal information to third parties.
            </p>
          </div>
          <div data-id="element-113" data-mp="2l7doepgm0ilo">
            <h4 className="font-bold text-slate-900" data-id="element-114" data-mp="2q0oz51ojljiv">Text Messaging</h4>
            <p className="mt-1" data-id="element-115" data-mp="2q2ji4ag971kb">
              If you text us, your mobile number is used only to communicate about your
              service request. Message and data rates may apply. You may opt out at any
              time by replying STOP.
            </p>
          </div>
          <div data-id="element-116" data-mp="22be31xi50db2">
            <h4 className="font-bold text-slate-900" data-id="element-117" data-mp="22cynuvenghvq">Contact</h4>
            <p className="mt-1" data-id="element-118" data-mp="278w7pbp4g6d9">
              Questions about this policy? Call or text us at {SITE.phone}.
            </p>
          </div>
        </div>
      </LegalModal>

      <LegalModal open={modal === 'terms'} onClose={() => setModal(null)} title="Terms of Service" data-id="element-119" data-mp="3ipnghwkuchn4">
        <div className="space-y-4" data-id="element-120" data-mp="3mq6anxa7hzsh">
          <p data-id="element-121" data-mp="3mp4n4tc07ktv">
            These terms govern the services provided by {SITE.company}, Texas State
            Irrigation License {SITE.license}. By requesting service, you agree to the
            following.
          </p>
          <div data-id="element-122" data-mp="173vdbhv6sj29">
            <h4 className="font-bold text-slate-900" data-id="element-123" data-mp="12b2a4yfd9isa">Diagnostics & Quotes</h4>
            <p className="mt-1" data-id="element-124" data-mp="128xwhoro15et">
              Quotes are based on the conditions observed at the time of our
              professional diagnostic inspection. Additional issues discovered during work may affect the final
              scope and price, which we will communicate before proceeding.
            </p>
          </div>
          <div data-id="element-125" data-mp="jbwnztywkn64">
            <h4 className="font-bold text-slate-900" data-id="element-126" data-mp="jbejka2372n4">Workmanship & Warranty</h4>
            <p className="mt-1" data-id="element-127" data-mp="edd0vq8kp5c6">
              We stand behind our work. If a repair we made or a system we installed
              fails due to our workmanship, we will return and make it right.
              Manufacturer warranties on parts and equipment are passed through to the
              customer where applicable.
            </p>
          </div>
          <div data-id="element-128" data-mp="1hmaa89abccv5">
            <h4 className="font-bold text-slate-900" data-id="element-129" data-mp="1hnv4dxspttsh">Insurance & Liability</h4>
            <p className="mt-1" data-id="element-130" data-mp="1mkbu2wfkcg7o">
              Northface Irrigation carries full workman's insurance on every job. This
              protects you from liability related to worker injury or unexpected damage
              during the course of our work.
            </p>
          </div>
          <div data-id="element-131" data-mp="yuhh8ev8urnf">
            <h4 className="font-bold text-slate-900" data-id="element-132" data-mp="ytpnl9l7j3zs">Contact</h4>
            <p className="mt-1" data-id="element-133" data-mp="12x4c6on7osou">
              For questions about these terms, call or text us at {SITE.phone}.
            </p>
          </div>
        </div>
      </LegalModal>
    </footer>;
}